import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=08cbc4d0&scoped=true&"
import script from "./approval.vue?vue&type=script&lang=js&"
export * from "./approval.vue?vue&type=script&lang=js&"
import style0 from "./approval.vue?vue&type=style&index=0&id=08cbc4d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cbc4d0",
  null
  
)

component.options.__file = "approval.vue"
export default component.exports